import { DEFAULT_TASK_DAYS } from './bannerOptions';
import { FIELD_INPUT, FieldLabel, PillRow } from './bannerFormBits';
import type { BannerComposer } from './useBannerComposer';

/** By when: an optional date, and what happens to the banner after it. */
export function ByWhenField({ composer }: { composer: BannerComposer }) {
  const { completeBy, setCompleteBy, afterDue, setAfterDue, taskDef } = composer;
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      <div className="min-w-0">
        <FieldLabel
          text="Complete by"
          htmlFor="banner-complete-by"
          hint="Optional. The card shows a countdown to this date."
        >
          {completeBy && (
            <button
              type="button"
              onClick={() => setCompleteBy('')}
              className="flex-none text-xs font-medium text-gray-500 hover:text-gray-700"
            >
              Clear
            </button>
          )}
        </FieldLabel>
        <input
          id="banner-complete-by"
          type="datetime-local"
          value={completeBy}
          onChange={(e) => setCompleteBy(e.target.value)}
          className={`${FIELD_INPUT} h-[38px]`}
        />
      </div>
      {completeBy ? (
        <div className="min-w-0">
          <FieldLabel
            text="After that"
            hint={`Take it off: it leaves home screens at the date. Keep showing: it stays past the date, up to ${DEFAULT_TASK_DAYS} days, saying when it was due.`}
          />
          <PillRow
            small
            options={[
              { value: 'take_off', label: 'Take it off' },
              { value: 'keep_showing', label: 'Keep showing' },
            ]}
            value={afterDue}
            onChange={setAfterDue}
          />
        </div>
      ) : (
        // Beside the box, where the two choices appear once there is a date.
        <p className="self-end pb-[9px] text-[13px] text-gray-500">
          {taskDef.doneWhen ? `Shows until done, up to ${DEFAULT_TASK_DAYS} days.` : `Shows for ${DEFAULT_TASK_DAYS} days.`}
        </p>
      )}
    </div>
  );
}
